<template>
  <v-card>
    <v-card-title>
      Create/edit map base
    </v-card-title>
    <v-card-text>
      <div>
        <v-select
          label="Liigat"
          :items="leagues ? leagues.filter(league => !league.archived) : []"
          multiple
          chips
          item-value="id"
          item-text="league_name"
          v-model="map_base.leagues"
          clearable
        />
      </div>
      <DynamicMap
        :maxHeight="600"
        :maxWidth="600"
        v-if="map_base.url"
        :image_url="map_base.url"
        @click="handleMapClick"
      />
      <div class="pa-3">
        <v-chip label v-if="latestClick.x">X: {{ latestClick.x.toFixed(4) }}</v-chip>
        <v-chip label class="ml-2" v-if="latestClick.y">Y: {{ latestClick.y.toFixed(4) }}</v-chip>
      </div>
      <v-text-field v-model="map_base.url" label="Image url" />
      <v-text-field v-model="map_base.title" label="Title" />
      <v-row>
        <v-col
          cols="3"
          v-for="offset in ['top', 'left', 'bottom', 'right']"
          :key="offset"
        >
          <v-text-field v-model="map_base['offset_' + offset]" :label="'Offset ' + offset" />
        </v-col>
      </v-row>
      <div style="max-width: 200px">
        <v-select
          clearable
          label="Tyyppi"
          :items="['field', 'plate']"
          v-model="map_base.map_type"
        />
      </div>
      <div style="height: 400px;" id="jsonEditor"></div>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" v-if="editing" @click="deleting = true">
        Poista
      </v-btn>
      <v-spacer />
      <v-btn
        color="primary"
        @click="save"
      >
        {{ editing ? 'Tallenna' : 'Luo' }}
      </v-btn>
    </v-card-actions>
    <ConfirmationDialog
      :show="deleting"
      text="Poista kartta?"
      btnColor="red"
      btnText="Poista"
      subText="Kartta poistetaan pysyvästi."
      @decline="deleting = false"
      @accept="startDelete"
    />
  </v-card>
</template>

<script>
import JSONEditor from 'jsoneditor'
import 'jsoneditor/dist/jsoneditor.css'
import DynamicMap from '@/components/maps/DynamicMap.vue';
import { mapActions, mapGetters } from 'vuex';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';

export default {
  props: ['edit_map_base'],
  mounted() {
    this.editing = false
    const container = document.querySelector('#jsonEditor')

    const options = {
      mode: 'code',
      onChange: this.onChange
    }

    this.jsonEditor = new JSONEditor(container, options)

    if (this.edit_map_base) {
      this.map_base = { ...this.map_base, ...this.edit_map_base };
      try {
        const dimensions = JSON.parse(this.edit_map_base.dimensions || '{}');
        this.jsonEditor.set(dimensions);
      } catch (e) {
        console.error('Invalid JSON in dimensions:', e);
        this.jsonEditor.set({});
      }
      this.editing = true;
    }
  },
  components: { DynamicMap, ConfirmationDialog },
  data: () => ({
    deleting: false,
    map_base: {
      leagues: [], // list of league_ids
      title: '',
      url: '',
      offset_top: 0,
      offset_left: 0,
      offset_bottom: 0,
      offset_right: 0,
      dimensions: {},
      map_type: null // field | plate
    },
    editing: false,
    jsonEditor: null,
    latestClick: {
      x: 0,
      y: 0
    }
  }),
  methods: {
    ...mapActions('admin', [
      'deleteMap',
      'initAdminMaps',
      'updateMap',
      'archiveMap',
      'createMap'
    ]),
    ...mapActions('noti', [
      'success',
      'error',
      'info'
    ]),
    startDelete() {
      this.deleteMap(this.map_base.id)
        .then(() => {
          this.info('Deleted');
          this.$emit('close');
        })
        .catch(e => {
          console.error('Delete failed:', e);
          this.error(e);
        });
    },
    onChange() {
      this.map_base.dimensions = JSON.stringify(this.jsonEditor.get());
    },
    handleMapClick(e) {
      this.latestClick = e
    },
    save() {
      console.log('Saving map_base:', this.map_base);
      let prom = this.editing
        ? this.updateMap({ id: this.map_base.id, updates: this.map_base })
        : this.createMap(this.map_base);

      prom
        .then(() => {
          console.log('Saved successfully');
          this.$emit('close');
          this.success(this.editing ? 'Updated' : 'Created');
        })
        .catch(e => {
          console.error('Save failed:', e);
          this.error(e);
        });
    },
  },
  computed: {
    ...mapGetters('admin', [
      'leagues'
    ])
  }
}
</script>